import {ComponentRegistry} from '../../components/component-registry';
import {DataApi} from '../../api/data-api/data-api';
import {NewsFilter, NewsSettings} from './filter';
import {AbstractLatest} from '../abstract-latest';

/**
 * Latest news items.
 *
 * @author Philipp Seiler <sep@earlybird.at>
 */
export class Latest extends AbstractLatest<NewsFilter, NewsSettings> {
  constructor(container: HTMLElement) {
    super(container);
    this.find();
    ComponentRegistry.add('news-latest', this);
  }

  /**
   * Finds latest news items.
   */
  protected find(): void {
    DataApi.instance.newsEndpoint.find(this.settings, null)
      .then(response => {
        if (this.isResultEmpty(response)) {
          this.empty();
          return;
        }
        this.notEmpty();

        let html = '';
        let i = 0;
        for (const document of response.documents) {
          const template = require('../../handlebars/templates/news/item.handlebars');
          html += template({
            document: document,
            isLast: i === response.documents.length - 1,
            iteration: i++
          });
        }
        this.update(html);

        this.emitter.emit('change', this);
      })
      .catch(e => {
        this.error(e);
      });
  }
}
